import {
  BaseUXComponent,
  UXComponentType
} from '../UXComponentRenderer/uxComponent.types'
import { UXComponent } from '../UXComponentRenderer/uxComponent'

export enum RowType {
  SINGLE = 'single',
  DOUBLE = 'double'
}

type SwimlaneAttributes = {
  rowType: RowType
  items: UXComponent[]
  spaceBetween?: number
  pagination?: boolean
  justifyContent?: string
}

export type Swimlane = BaseUXComponent<UXComponentType.Swimlane> & {
  attributes: SwimlaneAttributes
}
